import { useQueryClient } from '@tanstack/react-query'
import { useTeam } from 'app/frontend/base/config/context/team'
import useReferenceStore from 'app/frontend/base/state/useReferenceStore'

const useApplyEventUpdate = () => {
  const queryClient = useQueryClient()
  const { team } = useTeam()
  const { storeReferences } = useReferenceStore()

  return (event: wowaudit.Event) => {
    queryClient.setQueryData(
      ['teamEvent', { teamId: team.id, eventId: event.id }],
      event,
    )
    queryClient.setQueryData(
      ['teamEvents', { id: team.id }],
      (previous: wowaudit.EventReference[] | undefined) => {
        if (!previous) return previous
        return previous.map((eventReference) =>
          eventReference.id === event.id
            ? { ...eventReference, ...event }
            : eventReference,
        )
      },
    )
    storeReferences([event])
  }
}

export default useApplyEventUpdate
